module.exports = __webpack_public_path__ + "static/portfolio1b-b72012e7a82b6e6a66c2865dbf3c1044.jpg";